import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterdishesList'
})
export class FilterPipe implements PipeTransform {
    transform(dishes: any, term?: any): any {
        if (term === undefined) return dishes;
        if (term === null) return dishes;

        if (dishes != null) {
            return dishes.filter(function (dish) {
                if (dish.name_es != undefined)
                    if (dish.name_es.toString().toLowerCase().includes(term.toLowerCase()))
                        return dish;
                if (dish.name_en != undefined)
                    if (dish.name_en.toString().toLowerCase().includes(term.toLowerCase()))
                        return dish;
                if (dish.name_ca != undefined)
                    if (dish.name_ca.toString().toLowerCase().includes(term.toLowerCase()))
                        return dish;
                if (dish.name_de != undefined)
                    if (dish.name_de.toString().toLowerCase().includes(term.toLowerCase()))
                        return dish;
                if (dish.name_fr != undefined)
                    if (dish.name_fr.toString().toLowerCase().includes(term.toLowerCase()))
                        return dish;
                if (dish.name_it != undefined)
                    if (dish.name_it.toString().toLowerCase().includes(term.toLowerCase()))
                        return dish;
                if (dish.tags_static != undefined)
                    if (dish.tags_static.toString().toLowerCase().includes(term.toLowerCase()))
                        return dish;
                if (dish.tags != undefined)
                    if (dish.tags.toString().toLowerCase().includes(term.toLowerCase()))
                        return dish;
                if (dish.foodcost_static != undefined)
                    if (dish.foodcost_static == term)
                        return dish;
                if (dish.price != undefined)
                    if (dish.price == term)
                        return dish;

            })
        }



    }
}


// WEBPACK FOOTER //
// ./src/pages/dish/filter.pipe.ts